<script lang="ts" setup>
import { useMicrosoftAuthorizationForPlannerAccount } from '@/hooks/useMicrosoftAuthorization'
import { computed, watch } from 'vue'
import * as Sentry from '@sentry/vue'
import { useRoute, useRouter } from 'vue-router'
import { getQuery } from '@/libs/utilities/getQuery'

const router = useRouter()
const route = useRoute('settingsCalendarAuthCallback')

const entranceGUID = getQuery(route.query.entranceGUID)

const microsoftAuthForPlannerAccount =
  useMicrosoftAuthorizationForPlannerAccount(entranceGUID)

const code = computed(() => getQuery(route.query.code))

if (code.value) {
  await microsoftAuthForPlannerAccount.storeOAuthCredential(code.value)

  // eslint-disable-next-line fp/no-mutating-methods
  router.push({
    name: 'calendarSetting',
    params: {
      entranceGUID: entranceGUID,
    },
  })
}

const error = computed(() => getQuery('error'))
const errorSubCode = computed(() => getQuery('error_subcode'))

watch([error, errorSubCode], ([newError, newErrorSubCode]) => {
  if (!newError) {
    return
  }

  if (errorSubCode.value === 'cancel') {
    // cancel はユーザー起因のエラーなのでSentry に送らない
    return
  }

  Sentry.withScope(scope => {
    scope.captureMessage('failed to calendar auth callback.')
    scope.setExtra('error', newError)
    scope.setExtra('error_subcode', newErrorSubCode)
  })
})
</script>

<template>
  <p v-if="code">処理中です...</p>
  <p v-if="error">
    <span>error: {{ error }}</span
    ><br />
    <span>error_subcode: {{ errorSubCode }}</span
    ><br />
    <RouterLink
      :to="{ name: 'calendarSetting', params: { entranceGUID: entranceGUID } }"
    >
      設定画面に戻る
    </RouterLink>
  </p>
</template>
